import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ProfileUser } from '../../authentication/user';
import { AuthService } from '../../authentication/service/auth.service';
import { Router } from '@angular/router';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { WorkerService } from '../service/worker.service';
import { WorkerInfo } from '../worker';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { FirebaseHelperService } from '../../core/firebase/firebase-helper.service';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { SellerApiService } from '../../seller/service/seller-api.service';
// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-worker-header',
  templateUrl: './worker-header.component.html',
  styleUrls: ['./worker-header.component.scss']
})
export class WorkerHeaderComponent implements OnInit {

  // tslint:disable-next-line:no-inferrable-types
  roleName: string = '';
  workerInfo: WorkerInfo = new WorkerInfo();
  public currentWorkerUserId: number = null;
  public currentWorkerId: number = null;
  public currentSellerUserId: number = null;
  public currentSellerId: number = null;
  unReadMessageCount: Array<any> = [];
  projectArray: Array<any> = [];
  isMessageAvailable: boolean;
  tabIdentify: string;
  version: string;
  fileData: Array<any> = [];
  @ViewChild('RemoveSellerProfilePicture') RemoveSellerProfilePicture: ElementRef;

  constructor(private router: Router, public auth: AuthService,
    private cognitoService: CognitoUtil, private workerService: WorkerService,
    private firebaseHelperService: FirebaseHelperService, private sellerService: SellerApiService,
    private globalEventsManager: GlobalEventsManager ) {
      this.globalEventsManager.showNavBarRoleNameEmitter.subscribe((mode) => {
        this.roleName = mode;
       });

       this.globalEventsManager.sendNotificationWorkerNameEmitter.subscribe((mode) => {
        // tslint:disable-next-line:prefer-const
        let userDetails = this.cognitoService.getCurrentUser();
        this.callNotification(userDetails.username);
       });

       this.globalEventsManager.sendReadMessageArrayEmitter.subscribe((mode) => {
        if (mode.length > 0) {
          this.unReadMessageCount = mode;
          this.isMessageAvailable = false;
          this.globalEventsManager.sendMessageArray(this.unReadMessageCount);
          this.isAvailableMessages();
        }
      });
     }

  ngOnInit() {
    this.version = environment.VERSION;
    this.tabIdentify = 'SafetyBox';
    this.workerInfo = new WorkerInfo();
       // tslint:disable-next-line:prefer-const
       let userDetails = this.cognitoService.getCurrentUser();
       if (userDetails != null) {
         // get User Details By username
         this.workerService.getworkerDetailsByWorker_UserName(userDetails.username).subscribe(res => {
           if (res != null) {
             this.workerInfo = res;
             // Define Worker Id and Particular Seller Id Define for that Person
             this.currentWorkerUserId = res.user_id;
             this.currentWorkerId = res.worker_id;
             this.currentSellerUserId = res.seller_user_id;
             this.currentSellerId = res.seller_id;
             localStorage.removeItem('yasoUserFirstName');
             localStorage.setItem('yasoUserFirstName', this.workerInfo.worker_name);
             this.callNotification(userDetails.username);
           }
         }, err => {
           console.log(err);
         });

       }


  }

  callNotification(username) {
    this.workerService.getallNotificationDetails(username).subscribe(res => {
      if (res != null) {
        for (let index = 0; index < res.length; index++) {
          this.unReadMessageCount.push({ 'projectid': res[index], 'count': 0 });
          this.getLatestUnreadMessageCount(res[index]);
        }
      }
    }, err => {
      console.log(err);
    });
  }

    // Get the UnRead Message Count for each project
   async getLatestUnreadMessageCount(projectid: number) {
      await this.firebaseHelperService.getAllCoWorkerMessages(projectid, this.currentSellerId).subscribe(res => {
        this.firebaseHelperService.getLatestCoWorkerLogTime(projectid, this.currentSellerId, this.currentWorkerUserId).then(res1 => {
          if (res1.val()) {
            this.firebaseHelperService.getLatestCoWorkerUnReadMessages(projectid,
              this.currentSellerId, res1.val().lastReadTime).then(res2 => {
              if (res2.val()) {
                this.isMessageAvailable = false;
                this.unReadMessageCount.find(v => v.projectid === projectid).count = res2.numChildren();
                this.globalEventsManager.sendMessageArray(this.unReadMessageCount);
                this.isAvailableMessages();
              }
            });
          }
        });
      });
      // this.firebaseHelperService.getLatestCoWorkerLogTime(projectid,
      //   this.currentSellerId, this.currentWorkerUserId).subscribe(res => {
      //     if (res.length > 0) {
      //       this.getLatestUnreadMessageCountByLatest(projectid, res[0].payload.val());
      //     }
      //   });
    }
    // using Logtime and ProjectId //  get the messages count
    // getLatestUnreadMessageCountByLatest(projectid, logtime) {
    //   // tslint:disable-next-line:prefer-const
    //   let logmodi =  moment(logtime).add(0.5, 'm').toDate();
    //   this.firebaseHelperService.getLatestCoWorkerUnReadMessages(projectid,
    //     this.currentSellerId, new Date(logmodi).getTime()).subscribe(res => {
    //       this.isMessageAvailable = false;
    //       this.unReadMessageCount.find(v => v.projectid === projectid).count = res.length;
    //       this.globalEventsManager.sendMessageArray(this.unReadMessageCount);
    //       this.isAvailableMessages();
    //     });
    // }


    isAvailableMessages() {
      this.unReadMessageCount.filter(item => {
        if (item.count > 0) {
          this.isMessageAvailable = true;
          return;
        }
      });
    }

  private checkAuthentication() {
    Observable.fromPromise(this.auth.isAuthenticated())
      .map(isAuthed => {
        return isAuthed;
      });
  }

  callCommonFunction(url): void {
    if (url === '/worker/timesheets') {
      this.tabIdentify = 'TimeSheet';
    } else {
      this.tabIdentify = 'SafetyBox';
    }
    this.router.navigate([url]);
  }

  // upload worker image
  uploadworkerimage() {
// tslint:disable-next-line: prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
   // this.loaderActivate = true;
      this.sellerService.upload_image(this.fileData, userDetails.username).finally(() => {
       //  this.loaderActivate = false;
      }).subscribe(res => {
       this.fileData = [];
      }, err => {
        console.log(err);
      });
  }

   // photo upload select file
   onSelectFile(event) {
    this.fileData = [];
    if (event.target.files && event.target.files[0]) {
      this.fileData.push(event.target.files[0]);
      // tslint:disable-next-line:prefer-const
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      // tslint:disable-next-line:no-shadowed-variable
      reader.onload = (event: Event) => { // called once readAsDataURL is completed
        this.workerInfo.image_url = reader.result;
        this.uploadworkerimage();
      };
    }
  }

  // Delete Profile Pic
  deletprofilepicopenmodal() {
    $(this.RemoveSellerProfilePicture.nativeElement).modal('show');
  }

  // decline
  declineDeleteProfilePic() {
    $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
  }

  // Remove Worker Image
  confirmToRemoveProfilepic() {
    if (this.fileData.length === 0) {
      // tslint:disable-next-line: prefer-const
      let userDetails = this.cognitoService.getCurrentUser();
      // this.loaderActivate = true;
      this.workerService.removeWorkerProfilePic(userDetails.username).finally(() => {
        //  this.loaderActivate = false;
      }).subscribe(res => {
        $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
        this.workerInfo.image_url = null;
      }, err => {
        console.log(err);
        $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
        this.workerInfo.image_url = null;
      });
    }else {
      $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
      this.workerInfo.image_url = null;
      this.fileData = [];
    }

  }



}



// WEBPACK FOOTER //
// ./src/app/worker/worker-header/worker-header.component.ts